<router-outlet>
</router-outlet>
<input type="hidden" Id="network" (click)="open(networkError)"> 
<ng-template #networkError let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            
            <div>
               
                <p class="size18">your internet is down , Please check your internet connection.</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
            </div>
        </div>
    </div>
  </ng-template>